import React from 'react';
import { IntlProvider } from 'react-intl';
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';

import { Loading, ErrorBoundary, Notifications } from 'src/core/components';
import { routes as routeConstants, config } from 'src/constants';
import { getLoggedUserData } from 'src/utils';
import messages from 'src/i18n';
import { RNAOligosPage } from 'src/pages';
import 'src/assets/sass/global.scss';

import './App.scss';

const AppComponent = () => {
  const routes = [{ path: routeConstants.RNA_OLIGOS_PAGE, component: RNAOligosPage }];

  const user = getLoggedUserData();
  const defaultLocale = 'en';

  return (
    <IntlProvider
      key={user.locale}
      locale={user.locale}
      messages={messages[user.locale] ? messages[user.locale] : messages[defaultLocale]}
    >
      <ErrorBoundary>
        <Router basename={config.baseRoute}>
          <Switch>
            {routes.map((route) => (
              <Route
                key={route.path}
                path={route.path}
                exact
                component={route.component}
              />
            ))}
          </Switch>
        </Router>
        <Loading />
        <Notifications />
      </ErrorBoundary>
    </IntlProvider>
  );
};

export default AppComponent;
